jQuery(document).ready(function(){

    jQuery('.featuredSponsors').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        prevArrow:"<button style='background: none; border: none;' type='button' class='slick-prev pull-left'><div class='sponsorPrevArrow'></div></button>",
        nextArrow:"<button style='background: none; border: none;' type='button' class='slick-next pull-right'><div class='sponsorNextArrow'></div></button>",
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });
    jQuery('.generalContentGallery').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<button style='background: none; border: none;' type='button' class='slick-prev pull-left'><div class='generalPrevArrow'></div></button>",
      nextArrow:"<button style='background: none; border: none;' type='button' class='slick-next pull-right'><div class='generalNextArrow'></div></button>",
      responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
      ]
    });
  });

  jQuery('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = jQuery(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});

jQuery('.toggle').on('click', function(e) {
  jQuery(this).find('.svg-inline--fa').toggleClass('fa-times fa-caret-down');//you can list several class names 
});

jQuery( "#searchSubmit" ).click(function() {
  jQuery( "#yourFormId" ).submit();
});

jQuery('#fixedGlass').on('click', function(e) { 
  jQuery('.fixedIcon').fadeOut(250, function(){ jQuery('#fixedSearch').fadeIn(250); });
  jQuery('#fixedGlass').fadeOut(250, function(){ jQuery('#fixedX').fadeIn(250); });
});

jQuery('#fixedX').on('click', function(e) { 
  jQuery('#fixedSearch').fadeOut(250, function(){ jQuery('.fixedIcon').fadeIn(250); });
  jQuery('#fixedX').fadeOut(250, function(){ jQuery('#fixedGlass').fadeIn(250); });
});

(function($) {          
  $(document).ready(function(){

    $(function() {
      var Accordion = function(el, multiple) {
        this.el = el || {};
        // more then one submenu open?
        this.multiple = multiple || false;
        
        var dropdownlink = this.el.find('.parent-item');
        dropdownlink.on('click',
                        { el: this.el, multiple: this.multiple },
                        this.dropdown);
      };
      
      Accordion.prototype.dropdown = function(e) {
        var $el = e.data.el,
            $this = $(this),
            //this is the ul.submenuItems
            $next = $this.next();
        
        $next.slideToggle();
        $this.parent().toggleClass('open');
        
        if(!e.data.multiple) {
          //show only one menu at the same time
          $el.find('.sub-item').not($next).slideUp().parent().removeClass('open');
        }
      }
      
      var accordion = new Accordion($('.accordion-menu'), false);
    });
    
    var $hamburger = $(".hamburger");
    $hamburger.on("click", function(e) {
      $hamburger.toggleClass("is-active");
      $('.mobileMenu').toggleClass("isDown");
      if ( $('.mobileMenu').hasClass("isDown") ) {
        $('.mobileMenu').stop().animate({"top":"0%"}, 300);                          
      } else {
        $(".mobileMenu").stop().animate({"top":"-91%"}, 300);
      }
      
    });

      $(window).scroll(function(){                          
          if ($(this).scrollTop() > 175) {
              $('.fixedMenu').fadeIn(500);
          } else {
              $('.fixedMenu').fadeOut(200);
          }
      });

      var $ticket = $(".sideTicket");

      $ticket.on("click", function(e) {
        //$('.sideTicket').stop().animate({"right":"0px"}); 
      });
  });
})(jQuery);

